export default __webpack_public_path__ + "static/media/south_africa_flag.719fd233.png";